import { Select } from "grommet";
import React, { useMemo } from "react";
import './YearSelection.css';

type YearSelectionType = {
  onYearSelected: (arg: string) => void;
  selectedYear: string;
  onMonthSelected: (org: string) => void;
};

// const generateYears = () => {
//   const currentYear = new Date().getFullYear();
//   const totalYears = 10;
//   const years = [];
//   for (let i = 0; i < totalYears; i++) {
//     years.push((currentYear - i).toString());
//   }
//   return years;
// };

const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const totalYears = 10;
  const years = [];
  for (let i = -totalYears; i <= totalYears; i++) {
    years.push((currentYear + i).toString());
  }
  return years;
};


function YearSelection({ onYearSelected, onMonthSelected, selectedYear }: YearSelectionType) {
  const yearsList = useMemo(() => generateYears(), []);
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  return (
    <div className="year-selection-main">
      <div className="month-section">
        <span className="filter-title">MONTH</span>
        <div className="list-outer">
          <ul className="list">
            {months.map((item, index) =>{
              return(
                <li onClick={() => onMonthSelected((index).toString())}>{item}</li>
              )
            })}
          </ul>
        </div>
      </div>
    {/* <Select
        options={yearsList}
        value={selectedYear}
        onChange={({ option }) => onYearSelected(option)}
        style={{borderColor: '#4B628A',color: '#4B628A'}}
      /> */}

      <div style={{width: '50%',textAlign: 'center'}}>
        <span className="filter-title">YEAR</span>
        <div className="list-outer">
          <ul className="list">
            {yearsList.map((item) =>{
              return(
                <li onClick={() =>  onYearSelected(item)}>{item}</li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default YearSelection;
